import { IPageSteps } from './PageStepperProps'

export const ApplicationStates = {
   FORM: 1,
   BANK_VERIFICATION: 2,
   CHOOSE_OFFERT: 3,
   SIGN_CONTRACT: 4,
   FOUNDS_WITHDRAWAL: 5,
}


/**
 * Obiekt opisujący poszczególne kroki steppera.
 * applicationState - W jakim stanie ma znajdować się aplikacja aby dany krok był zaznaczony jako kompletny
 */
export const pageSteps: IPageSteps[] = [
   {
      id: 1,
      applicationState: ApplicationStates.FORM,
      label: "Wniosek",
      stepNumberToDisplay: 1,
   },
   {
      id: 2,
      applicationState: ApplicationStates.BANK_VERIFICATION,
      label: "Weryfikacja",
      stepNumberToDisplay: 2,
   },
   {
      id: 3,
      applicationState: ApplicationStates.CHOOSE_OFFERT,
      label: "Oferta",
      stepNumberToDisplay: 3,
   },
   {
      id: 4,
      applicationState: ApplicationStates.SIGN_CONTRACT,
      label: "Wypłata",
      stepNumberToDisplay: 4,
   },
]